import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Icons } from '../../../../../packages/icons';
import { colors } from '../../../../../packages/colors';
import { sx } from '../SessionSignOffV4.styles';
import {
  fetchSessionReportCard,
  updatePatientSummary,
} from '../../../../../services/report-service/reportService.service';
import { ReportCard } from '../../../../../packages/ui/templates/sign-off/components/report/ReportCard';
import { PatientSummary } from './PatientSummary';

export const SessionReportSection = ({ appointment, openGiggle, waitingForAI }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [sessionReportCard, setSessionReportCard] = useState(null);
  const [isPatientSummaryOpen, setIsPatientSummaryOpen] = useState(false);

  const fetchSessionReport = () => {
    setIsLoading(true);
    fetchSessionReportCard({ appointmentId: appointment.appointmentId })
      .then(response => {
        setSessionReportCard(response.data.message);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (appointment?.appointmentId) {
      fetchSessionReport();
    }
  }, [appointment?.appointmentId]);

  const onUpdateSessionReportCard = patientSummary => {
    updatePatientSummary({ patientSummary: patientSummary }, { appointmentId: appointment.appointmentId })
      .then(() => {
        fetchSessionReport();
      })
      .catch(error => {
        console.error(error);
      });
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" flex={1}>
        <Icons className="rotate linear infinite" glyph="in-progress" color={colors.primary} />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap="40px" padding="16px">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 28,
            lineHeight: '36px',
            color: colors.neutral900,
          }}
        >
          Session report card
        </Typography>
        {/*<span className={{ color: colors.neutral600, fontWeight: 500, fontSize: '16px', lineHeight: '24px' }}>*/}
        {/*  A patient must have a diagnosis to bill insurance*/}
        {/*</span>*/}
      </Box>
      <ReportCard
        openQuickSummary={() => setIsPatientSummaryOpen(true)}
        sessionReportCard={sessionReportCard}
        waitingForAI={waitingForAI}
      />
      <PatientSummary
        isOpen={isPatientSummaryOpen}
        onClose={() => setIsPatientSummaryOpen(false)}
        patientSummary={sessionReportCard?.reportCard?.patientSummary}
        onSubmit={onUpdateSessionReportCard}
      />
    </Box>
  );
};
